import React from "react";

import SettingsIcon from "@uui/Settings04";

import {
  FloatingNavActionDivider,
  FloatingNavButton,
} from "@app/analytics/components/reports/FloatingNav";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import Menu, { MenuBody, MenuHeader } from "@rui/Menu";
import TooltipWrapper from "@rui/TooltipWrapper";

import RecapSettingsContent from "./RecapSettingsContent";

const RecapSettingsButtonAndMenu = () => {
  const { anchorElement, onClick, open, onClose } = useAnchorElement();

  return (
    <>
      <FloatingNavActionDivider />
      <TooltipWrapper placement="bottom" title="Settings">
        <FloatingNavButton Icon={SettingsIcon} onClick={onClick} active={open}>
          Settings
        </FloatingNavButton>
      </TooltipWrapper>
      <Menu
        open={open}
        onClose={onClose}
        anchorEl={anchorElement}
        disablePadding
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuHeader>
          <SettingsIcon />
          <span>Settings</span>
        </MenuHeader>
        <MenuBody spacing={0.5}>
          <RecapSettingsContent />
        </MenuBody>
      </Menu>
    </>
  );
};

export default RecapSettingsButtonAndMenu;
